export const entityTypes: EntityTypesProps = {
  0: 'user',
  1: 'farm',
  2: 'store',
  3: 'collaborator',
  4: 'warehouse',
  5: 'transport',
  6: 'volunteer',
};

export const entityTypesNumber: EntityTypesNumberProps = {
  user: 0,
  farm: 1,
  store: 2,
  collaborator: 3,
  warehouse: 4,
  transport: 5,
  volunteer: 6,
};

export const personStatusList = [
  { key: 'all', value: 'all', name: 'Tất cả các trạng thái' },
  { key: '0', value: 0, name: 'Đang hoạt động' },
  { key: '1', value: 1, name: 'Dừng hoạt động' },
  { key: '2', value: 2, name: 'Tạm dừng hoạt động' },
];

export const optionFindBase = {
  isVisible: true,
  whiteList: ['order', 'take', 'page', 'where'],
};

export const unitPrefixList = [
  {
    key: '0',
    value: 0,
    name: 'bỏ trống',
  },
  {
    key: '1',
    value: 1,
    name: 'bịch',
  },
  {
    key: '2',
    value: 2,
    name: 'hộp',
  },
  {
    key: '3',
    value: 3,
    name: 'vỉ',
  },
  {
    key: '4',
    value: 4,
    name: 'phần',
  },
  {
    key: '5',
    value: 5,
    name: 'cái',
  },
  {
    key: '6',
    value: 6,
    name: 'thùng',
  },
  {
    key: '7',
    value: 7,
    name: 'con',
  },
  {
    key: '8',
    value: 8,
    name: 'hũ',
  },
  {
    key: '9',
    value: 9,
    name: 'chai',
  },
  {
    key: '10',
    value: 10,
    name: 'bó',
  },
  {
    key: '11',
    value: 11,
    name: 'túi',
  },
  {
    key: '12',
    value: 12,
    name: 'ổ',
  },
  {
    key: '13',
    value: 13,
    name: 'set',
  },
  {
    key: '14',
    value: 14,
    name: 'trái',
  },
  {
    key: '15',
    value: 15,
    name: 'nải',
  },
  {
    key: '16',
    value: 16,
    name: 'lọ',
  },
  {
    key: '17',
    value: 17,
    name: 'cây',
  },
  {
    key: '100',
    value: 100,
    name: 'khác',
  },
];

export const unitPostfixList = [
  {
    key: '0',
    value: 0,
    name: 'gr',
  },
  {
    key: '1',
    value: 1,
    name: 'kg',
  },
  {
    key: '2',
    value: 2,
    name: 'yến',
  },
  {
    key: '3',
    value: 3,
    name: 'tạ',
  },
  {
    key: '4',
    value: 4,
    name: 'tấn',
  },
  {
    key: '5',
    value: 5,
    name: 'cm',
  },
  {
    key: '6',
    value: 6,
    name: 'm',
  },
  {
    key: '7',
    value: 7,
    name: 'quả',
  },
  {
    key: '8',
    value: 8,
    name: 'bịch',
  },
  {
    key: '9',
    value: 9,
    name: 'ml',
  },
  {
    key: '10',
    value: 10,
    name: 'l',
  },
  {
    key: '11',
    value: 11,
    name: 'nải',
  },
  {
    key: '12',
    value: 12,
    name: 'set',
  },
  {
    key: '13',
    value: 13,
    name: 'gói',
  },
  {
    key: '14',
    value: 14,
    name: 'cái',
  },
  {
    key: '15',
    value: 15,
    name: 'túi',
  },
  {
    key: '16',
    value: 16,
    name: 'con',
  },
  {
    key: '17',
    value: 17,
    name: 'hộp',
  },
  {
    key: '18',
    value: 18,
    name: 'chục',
  },
  {
    key: '19',
    value: 19,
    name: 'chai',
  },
  {
    key: '20',
    value: 20,
    name: 'thùng',
  },
  {
    key: '21',
    value: 21,
    name: 'hũ',
  },
  {
    key: '22',
    value: 22,
    name: 'khay',
  },
  {
    key: '23',
    value: 23,
    name: 'cặp',
  },
  {
    key: '24',
    value: 24,
    name: 'chiếc',
  },
  {
    key: '25',
    value: 25,
    name: 'lọ',
  },
  {
    key: '26',
    value: 26,
    name: 'đĩa',
  },
  {
    key: '27',
    value: 27,
    name: 'ống',
  },
  {
    key: '28',
    value: 28,
    name: 'niêu',
  },
  {
    key: '29',
    value: 29,
    name: 'vỉ',
  },
  {
    key: '30',
    value: 30,
    name: 'phần',
  },
  {
    key: '31',
    value: 31,
    name: 'cành',
  },
  {
    key: '32',
    value: 32,
    name: 'bó',
  },
  {
    key: '33',
    value: 33,
    name: 'ổ',
  },
  {
    key: '34',
    value: 34,
    name: 'cây',
  },
  {
    key: '35',
    value: 35,
    name: 'bắp',
  },
  {
    key: '100',
    value: 100,
    name: 'khác',
  },
];

interface EntityTypesProps {
  [key: number]: string;
}

interface EntityTypesNumberProps {
  [key: string]: number;
}
